import { configureStore } from '@reduxjs/toolkit';
import jobsReducer from '../features/jobs/jobsSlice';
import jobReducer from '../features/job/jobSlice';
import filterReducer from '../features/filter/filterSlice';

export const store = configureStore({
  reducer: {
    job: jobReducer,
    jobs: jobsReducer,
    filter: filterReducer
  },
});
